<template>
   <myDrawer :isDrawer="isDrawer" :isFooter="true" :title="'标签类型'" @drawerClose="drawerClose">
    <template slot="content">
        <el-form :model="labelForm" ref="labelForm" label-width="80px" :rules="rules">
            <el-form-item label="父级" prop="parentIds">
                <el-cascader v-model="labelForm.parentIds" :show-all-levels="false" :props="{ checkStrictly: true,value:'id' }" style="width: 100%;" :options="labelOptions"></el-cascader>
            </el-form-item>
            <el-form-item label="标签编码" prop="code">
                <el-input v-model="labelForm.code" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="标签名称" prop="name">
                <el-input v-model="labelForm.name" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input-number v-model="labelForm.sort" placeholder="" :step="1" step-strictly></el-input-number>
            </el-form-item>
            <el-form-item label="备注" prop="notes">
                <el-input v-model="labelForm.notes" type="textarea" placeholder="" :autosize="{minRows:5}"></el-input>
            </el-form-item>
        </el-form>
    </template>
    <template slot="footer">
        <el-button :disabled="ifSubmit" @click="submit" class="bcjx">保存</el-button>
    </template>
   </myDrawer>
</template>

<script>
import {bqlxTreeSelect,bqlxAdd,bqlxUpdate,bqlxDetail} from "@/api/bqgl.js";
export default {
    components:{},
    props:{
        isDrawer:{
            default:false,
            type:Boolean
        }
    },
    data() {
        return {
            ifSubmit:false,
            labelForm:{
                parentIds:null,
            },
            rules:{
                name:[
                    {required: true, message:'请输入', trigger: ['blur','change']}
                ],
                parentIds:[
                    {required: true, message:'请选择', trigger: ['blur','change']}
                ],
                code:[
                    {required: true, message:'请输入', trigger: ['blur','change']}
                ],
                sort:[
                    {required: true, message:'请输入', trigger: ['blur','change']}
                ]
            },
            labelOptions:[]
        }
    },
    mounted () {
        this.getLabelTree()
    },
    methods: {
        submit(){
            this.$refs.labelForm.validate(valid=>{
                if(valid){
                    this.ifSubmit = true;
                    let form=JSON.parse(JSON.stringify(this.labelForm))
                    form.parentId=form.parentIds?form.parentIds[form.parentIds.length-1]:'';
                    delete form.parentIds
                    if(form.id){
                        bqlxUpdate(form).then(res=>{
                            if(res && res.code==200){
                                this.msgSuccess('修改成功');
                                this.drawerClose();
                                this.ifSubmit=false;
                                this.$parent.getLabelType();
                                this.initForm();
                            }
                        }).catch(()=>{
                            this.ifSubmit=false
                        })
                    }else{
                        bqlxAdd(form).then(res=>{
                            if(res && res.code==200){
                                this.msgSuccess('创建成功');
                                this.drawerClose();
                                this.ifSubmit=false;
                                this.$parent.getLabelType();
                                this.initForm();
                            }
                        }).catch(()=>{
                            this.ifSubmit=false
                        })
                    } 
                }
            })
        },
        initForm(){
            this.labelForm=this.$options.data().labelForm;
            this.getLabelTree();
        },
        getLabelTree(){
            bqlxTreeSelect({}).then(res=>{
                if(res && res.code==200 && res.data){
                    this.labelOptions=[];
                    const label = {id: "0", label: '主类目', children: []};
                    label.children = this.handleTree(res.data, "id", "parentId");
                    this.labelOptions.push(label);
                }
            })
        },
        getDetail(id){
            bqlxDetail({id}).then(res=>{
                if(res && res.code==200 && res.data){
                    this.labelForm=res.data;
                    this.labelForm.parentIds=res.data.parentIds?res.data.parentIds.split(","):[];
                }
            })
        },
        drawerClose(){
            this.$emit("update:isDrawer");
            this.initForm();
        },
         /** 转换类型数据结构 */
        normalizer(node) {
            if (node.children && !node.children.length) {
                delete node.children;
            }
            return {
                id: node.id,
                label: node.menuName,
                children: node.children
            };
        },
    }
}
</script>

<style lang="scss" scoped>
 /deep/ .footer {
    .bcjx {
        width: 120px;
        height: 40px;
        border-radius: 2px;
        background: rgba(12, 123, 242, 1);
        color: rgba(255, 255, 255, 1);
        font-family: OPPOSans;
        font-weight: bold;
        font-size: 14px;
        text-align: center;
        line-height: 40px;
        padding: 0px;
        margin-left: 40px;
    }
}
</style>